// extracted by mini-css-extract-plugin
module.exports = {"options":"_1A0B3","label":"_3dpj1","labelText":"_1Cv08","checkbox":"_1LXRy"};